import { render, staticRenderFns } from "./sysDdtype.vue?vue&type=template&id=529b75c5&scoped=true&"
import script from "./sysDdtype.vue?vue&type=script&lang=js&"
export * from "./sysDdtype.vue?vue&type=script&lang=js&"
import style0 from "./sysDdtype.vue?vue&type=style&index=0&id=529b75c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529b75c5",
  null
  
)

export default component.exports